<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Ordenes nuevas</h3>
        </div>
        <div class="col text-right">
          <a href="#/Orders"><base-button size="sm" type="primary btn_info_list">Ver todo</base-button></a>

        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light"
                  :data="orders">
        <template slot="columns">
          <th># Orden</th>
          <th>Fecha</th>
          <th>Estado</th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            {{row.order_id}}
          </th>
          <td>
            {{formatedate(row.order_date)}}
          </td>
          <td>
          {{row.OrderStatus.status}}
          </td>
        </template>

      </base-table>
    </div>

  </div>
</template>
<script>
  import {bus} from "@/components/Order/bus-order";
  import {order_service} from "@/services/order/OrderService";

  export default {
    name: 'social-traffic-table',
    data() {
      return {
        orders2:[],
        orders:[],
        value:0,
        page_count:0,
        tableData: [
          {
            name: 'La cocina',
            visitors: '1,480',
            progress: 60,
            progressType: 'gradient-danger',
          },
          {
            name: 'La olla',
            visitors: '5,480',
            progress: 70,
            progressType: 'gradient-success',
          },
          {
            name: 'La cuchara',
            visitors: '4,807',
            progress: 80,
            progressType: 'gradient-primary',
          },
          {
            name: 'El tenedor',
            visitors: '3,678',
            progress: 75,
            progressType: 'gradient-info',
          },
          {
            name: 'El trinchete',
            visitors: '2,645',
            progress: 30,
            progressType: 'gradient-warning',
          }
        ]
      }
    },
    methods:{
      formatedate(fecha) {
        var fechas = new Date(fecha)
        return fechas.toLocaleDateString()
      }
    },
    created() {
      order_service.GetAllOrder()
      bus.$on('GetAllOrder', (response, value) => {
        this.orders2 = response.sort(function (a, b) {
          return (a.order_id - b.order_id)
        })
        this.page_count = Math.ceil(value / 10)
        this.value = this.page_count
        console.log('llego')
        order_service.GetAllOrderPagination2(0)
      })
      bus.$on('GetAllOrderPagination2', (response) => {
        this.orders = response.sort(function (a, b) {
          return (a.order_id - b.order_id)
        })
      })
    }

  }
</script>
<style>
</style>
